import {
  Box,
  InputAdornment,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
// import AttachmentIcon from "../../../assets/images/attach.svg";
import MicIcon from "../../../assets/images/micIcon.svg";
import SendIcon from "../../../assets/images/sendArrow.svg";
import SingleSelectField from "Samarth Module/components/SamarthAi/SingleSelectField";
import { useEffect, useRef, useState } from "react";
import ExpandIcon from "../../../assets/images/expandmore1.svg";
import ExpandLessIcon from "../../../assets/images/expandless1.svg";
import { useLocation } from "react-router-dom";
const size = {
  xs: 16,
  md: 18,
  lg: 20,
};
const greenShade = {
  position: "relative",
  //   padding: "5px",
  borderRadius: "32px",
  "&:before": {
    background:
      "linear-gradient(145.45deg, #FFEC9A -130.81%, #CCF0EB 50.06%, #00B2FF 188.34%)",
    width: "100%",
    height: "100%",
    content: '""',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderRadius: "32px",
    position: "absolute",
    top: "0",
    left: "0",
    transform: "rotate(180deg)",
  },
  "&:after": {
    background:
      "linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.6) 100%)",
    width: "100%",
    height: "100%",
    content: '""',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderRadius: "32px",
    position: "absolute",
    top: "0",
    left: "0",
    transform: "rotate(180deg)",
  },
};

const smallIconStyle = {
  height: size,
  width: size,
};

const searchBox = {
  border: "1px solid #f0f0f0",
  background: "#FFFFFF",
  borderRadius: "32px",
  position: "relative",
  zIndex: "1",
  "&:has(.MuiOutlinedInput-root.Mui-focused)": {
    boxShadow: "0 0 0 1px #0066CC",
  },
};
const dropDownBox = {
  display: "flex",
  gap: "16px",
};
const actionContainerStyle = {
  display: "flex",
  gap: 2,
  justifyContent: "space-between",
  alignItems: "center",
};

const selectFieldStyle = {
  background: "linear-gradient(180deg, #C2E0FF 0%, #FFFFFF 70%)",
  border: "1px solid #C2E0FF",
  borderRadius: "10px",
};

const sendIconWrapperBase = {
  height: {
    sm: "36px",
    md: "44px",
    lg: "56px",
  },
  width: {
    sm: "36px",
    md: "44px",
    lg: "56px",
  },
  borderRadius: "50%",
  display: "grid",
  justifyContent: "center",
  alignItems: "center",
};
const sendIconWrapperStyle = (hasText) => ({
  ...sendIconWrapperBase,
  background: hasText ? "#0066CC" : "#DEDED7",

  "&:hover": {
    background: hasText ? "#0066CC" : "#DEDED7",
    cursor: "pointer",
  },
});
const capitalize = (text = "") => text.charAt(0).toUpperCase() + text.slice(1);

export const ChatInput = ({
  messages,
  newMessage,
  setNewMessage,
  onSend,
  selectedQuickValue,
  handleQuickChange,
  selectedOptionValue,
  handleOptionChange,
  quick_options,
  output_options,
  filterOpen,
  setFilterOpen,
  formValues,
  setFormValues,
}) => {
  const recognitionRef = useRef(null);
  const [isListening, setIsListening] = useState(false);
  const inputRef = useRef();
  const [isFocused, setIsFocused] = useState(false);
  const activeFilterCount = formValues
    ? Object.values(formValues).filter((v) => Array.isArray(v) && v.length > 0)
        .length
    : 0;
      const location = useLocation();
      const showTooltip = location.pathname === "/samarth/chat";
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Your browser does not support Speech Recognition");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = true;
    recognition.lang = "en-US";

    recognition.onstart = () => {
      setIsListening(true);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.onresult = (event) => {
      let transcript = "";

      for (let i = 0; i < event.results.length; i++) {
        transcript += event.results[i][0].transcript;
      }

      setNewMessage(transcript);
    };

    recognitionRef.current = recognition;
  }, [setNewMessage]);

  const handleMicClick = () => {
    if (!recognitionRef.current) return;

    if (isListening) {
      recognitionRef.current.stop();
    } else {
      recognitionRef.current.start();
    }
  };

  const hasMessages = messages?.length !== 0;
  const tooltipProps = {
    slotProps: {
      tooltip: {
        sx: {
          backgroundColor: "#F6F7F0 !important",
          color: "#1A2025",
          fontSize: "12px",
          p: "4px 16px !important",
          fontWeight: 400,
          borderRadius: "6px",
        },
      },
    },
  };
  // Filter button shared component
  const filterButton = (
    <Tooltip
      title="Your filters are available here. Choose filters to set context for your prompt."
      placement="top"
      disableHoverListener={!showTooltip}
      {...tooltipProps}
    >
      <Box
        onClick={() => setFilterOpen((prev) => !prev)}
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          gap: "6px",
          border: filterOpen ? "1px solid #0066CC" : "1px solid #D9E1E7",
          borderRadius: "24px",
          padding: { sm: "6px 10px", md: "4px 12px", lg: "8px 14px" },
          cursor: "pointer",
          transition: "all 0.2s ease",
          flexShrink: 0,
          backgroundColor: filterOpen ? "#C2E0FF" : "transparent",
          "&:hover": {
            backgroundColor: filterOpen ? "#C2E0FF" : "transparent",
          },
          height: { md: "33px", lg: "40px" },
        }}
      >
        <Box
          component="img"
          src={filterOpen ? ExpandLessIcon : ExpandIcon}
          sx={{ height: size, width: size }}
        />
        <Typography
          sx={{
            fontSize: { sm: "10px", md: "10px", lg: "12px" },
            fontWeight: 500,
            color: "#1A2025",
            whiteSpace: "nowrap",
          }}
        >
          Filter
        </Typography>

        {activeFilterCount > 0 && (
          <Box
            sx={{
              backgroundColor: filterOpen ? "#FFFFFF" : "#C2E0FF",
              color: "#0066CC",
              fontSize: "11px",
              fontWeight: 600,
              minWidth: "20px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50px",
              padding: "10px",
            }}
          >
            {activeFilterCount}
          </Box>
        )}
      </Box>
    </Tooltip>
  );

  return (
    <Box sx={greenShade}>
      <Box
        sx={{
          ...searchBox,
          display: "flex",
          flexDirection: hasMessages ? "row" : "column",
          gap: hasMessages
            ? {
                sm: "6px",
                md: "8px",
                lg: "8px",
              }
            : {
                sm: "36px",
                md: "48px",
                lg: "56px",
              },

          padding: hasMessages
            ? {
                sm: "8px 6px 8px 8px",
                md: "10px 8px 10px 10px",
                lg: "10px 8px 10px 10px",
              }
            : {
                sm: "16px",
                md: "18px",
                lg: "20px",
              },
          justifyContent: hasMessages ? "center" : "start",
          alignItems: hasMessages ? "center" : undefined,
          border: isFocused ? "1px solid #0066CC" : "1px solid #D9E1E7",
        }}
      >
        {/* Filter button - inline left when messages exist */}
        {hasMessages && filterButton}
        {hasMessages && activeFilterCount > 0 && (
          <>
            <Box
              sx={{
                width: "1px",
                height: "24px",
                backgroundColor: "#D0D5DD",
              }}
            />
            <Typography
              sx={{
                fontSize: { sm: "10px", md: "8px", lg: "12px" },
                fontWeight: 500,
                color: "#0066CC",
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => {
                const clearedValues = Object.keys(formValues || {}).reduce(
                  (acc, key) => {
                    acc[key] = [];
                    return acc;
                  },
                  {},
                );
                setFormValues(clearedValues);
              }}
            >
              Reset
            </Typography>
          </>
        )}
        <TextField
          inputRef={inputRef}
          fullWidth
          multiline
          minRows={1}
          maxRows={3}
          placeholder="Ask anything..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend();
              setNewMessage("");
              inputRef.current?.focus();
            }
          }}
          variant="outlined"
          sx={{
            mb: hasMessages ? 0 : 1,
            wordBreak: "break-word",
            flex: 1,
            "& .MuiOutlinedInput-root": {
              padding: 0,
              display: "flex",
              alignItems: "flex-start",
              maxHeight: "223px",
              overflowY: "auto",
              "&:hover, &.Mui-focused": { backgroundColor: "transparent" },
            },
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            "& .MuiInputBase-input": {
              padding: 0,
              fontSize: "16px",
              wordBreak: "break-word",
              color: "#1A2025",
            },
            "&:-webkit-autofill": {
              WebkitBoxShadow: "0 0 0 100px transparent inset",
              WebkitTextFillColor: "inherit",
              transition: "background-color 9999s ease-out 0s",
            },
          }}
          InputProps={{
            startAdornment: (
              <>
                {selectedQuickValue && (
                  <InputAdornment position="start">
                    {capitalize(selectedQuickValue)} /
                  </InputAdornment>
                )}
                {selectedOptionValue && (
                  <InputAdornment position="start">
                    {capitalize(selectedOptionValue)} /
                  </InputAdornment>
                )}
              </>
            ),
          }}
        />

        {/* Action icons - inline right when messages exist */}
        {hasMessages && (
          <Box sx={{ ...actionContainerStyle, flexShrink: 0 }}>
            <Box
              component="img"
              src={MicIcon}
              sx={{
                ...smallIconStyle,
                cursor: "pointer",
                opacity: isListening ? 0.5 : 1,
              }}
              onClick={handleMicClick}
            />
            <Box sx={sendIconWrapperStyle(newMessage.trim())} onClick={onSend}>
              <Box component="img" src={SendIcon} sx={smallIconStyle} />
            </Box>
          </Box>
        )}

        {/* Bottom bar - only when no messages (initial state) */}
        {!hasMessages && (
          <Box
            sx={{
              ...dropDownBox,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: {
                  md: "6px",
                  lg: "8px",
                },
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: {
                    md: "6px",
                    lg: "8px",
                  },
                  marginRight:
                    activeFilterCount > 0
                      ? {
                          md: "12px",
                          lg: "16px",
                        }
                      : "",
                }}
              >
                {filterButton}

                {/* Vertical Divider + Reset */}
                {activeFilterCount > 0 && (
                  <>
                    <Box
                      sx={{
                        width: "1px",
                        height: "24px",
                        backgroundColor: "#D0D5DD",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: { sm: "10px", md: "8px", lg: "12px" },
                        fontWeight: 500,
                        color: "#0066CC",
                        cursor: "pointer",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                      onClick={() => {
                        const clearedValues = Object.keys(
                          formValues || {},
                        ).reduce((acc, key) => {
                          acc[key] = [];
                          return acc;
                        }, {});
                        setFormValues(clearedValues);
                      }}
                    >
                      Reset
                    </Typography>
                  </>
                )}
              </Box>

              <Box sx={dropDownBox}>
                <SingleSelectField
                  placeholder="Output Format"
                  value={selectedOptionValue}
                  onChange={handleOptionChange}
                  options={output_options}
                  selectMarginTop="0"
                  // selectBorderRadius="10px"
                  selectPadding={{
                    sm: "6px 12px",
                    md: "8px 16px",
                    lg: "10px 20px",
                  }}
                  selectFontSize={{ sm: "10px", md: "12px", lg: "16px" }}
                  selectLineHeight={{ sm: "14px", md: "16px", lg: "18px" }}
                  sx={selectFieldStyle}
                  fullWidth={true}
                />
              </Box>
            </Box>
            <Box sx={actionContainerStyle}>
              <Box
                component="img"
                src={MicIcon}
                sx={{
                  ...smallIconStyle,
                  cursor: "pointer",
                  opacity: isListening ? 0.5 : 1,
                }}
                onClick={handleMicClick}
              />
              <Box
                sx={sendIconWrapperStyle(newMessage.trim())}
                onClick={onSend}
              >
                <Box component="img" src={SendIcon} sx={smallIconStyle} />
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
